<script>
import DecisionStatus from '../../../../../Constants/DecisionStatus.ts'
import ResidualMode from '../../../../../Constants/ResidualMode.ts'
import { Role } from '../../../../../Constants/Role.ts'
import BlockContent from '../../UI/Content/BlockContent.vue'
import EntityLink from '../../UI/Button/EntityLink.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import AlertList from '../../Alert/AlertList.vue'
import DocumentList from '../../Document/DocumentList.vue'
import ModalConfirmation from '../../UI/Modal/ModalConfirmation.vue'
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import ModalSuccess from '../../UI/Modal/ModalSuccess.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../../Mixins/global'
import DecisionDealModal from './DecisionDealModal.vue'
import MessageList from '../../Message/MessageList.vue'
import { useSimulationAcceptedDemands } from '../../../../../Composables/Demand/useSimulationAcceptedDemand.ts'

export default {
  components: {
    MessageList,
    DecisionDealModal,
    ModalConfirmation,
    ModalDialog,
    ModalSuccess,
    DocumentList,
    AlertList,
    ButtonAll,
    FieldCreator,
    FormCreator,
    EntityLink,
    BlockContent,
  },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    simulation: { type: Object },
    simulationDef: { type: Object },
    client: { type: Object, required: false },
  },

  setup(props) {
    const {
      data: acceptedDemandsSummary,
      loading: acceptedDemandsSummaryLoading,
      refresh: refreshAcceptedDemandsSummary,
    } = useSimulationAcceptedDemands(() => props.simulation?.id ?? null)

    return { acceptedDemandsSummary, acceptedDemandsSummaryLoading, refreshAcceptedDemandsSummary }
  },

  data() {
    return {
      isMessageVisible: false,
      isDemandVisible: false,
      isDocumentLoaded: true,
      decision: null,
      def: null,
      demand: null,
      refuseCheck: false,
      context: {
        context: 'AppBundle/Entity/Demand',
        contextId: 0,
      },
      providers: null,
      decisionId: null,
      sendingDemand: false,
      sendingResponse: false,
      sendingCommunication: false,
      sendingTransmit: false,
      sendingSelectDecision: false,
      sending: null,
      loading: false,
      collapseForm: [],
      collapseField: [],
      formDatas: [],
      secondFormData: {},
      recomputingDecision: null,
      success: '',
      timerEndDate: null,
      timerValue: null,
      updatePurchaseRateConfirming: null,
      updatePurchaseRateUpdating: null,
      isPurchaseRateChanged: [],
      isPurchaseRateSentChanged: [],
      decisions: [],
    }
  },

  emits: ['call:alert', 'demand-sent', 'update-simulation'],

  watch: {
    timerValue: {
      handler(value) {
        setTimeout(() => {
          if (this.timerEndDate !== null) {
            const now = DateTime.now()
            if (now >= this.timerEndDate) {
              this.timerEndDate = null
              location.reload()
            } else {
              const remaining = this.timerEndDate.diff(now, ['days', 'hours', 'minutes', 'seconds'])
              this.timerValue = this.getHTMLTimerValue(remaining)
            }
          }
        }, 1000)
      },
      immediate: true,
    },
  },

  computed: {
    DecisionStatus() {
      return DecisionStatus
    },
    mainDecisionId() {
      return this.simulation?.decision?.id
    },
    orderedDecisions() {
      return this.decisions.sort((decision1, decision2) => {
        // Comparaison par ordre d'éligibilité
        if (decision1.isEligible && !decision2.isEligible) {
          return -1
        }
        if (!decision1.isEligible && decision2.isEligible) {
          return 1
        }

        // Si les deux décisions sont éligibles ou non éligibles, comparer par nom du refinancer
        return decision1.refinancer.name.localeCompare(decision2.refinancer.name)
      })
    },
    messageListContext() {
      return [{ context: 'AppBundle\\Entity\\Simulation', contextId: this.simulation.id }]
    },
    scores() {
      return this.client?.lastScoreForAllProviders?.filter(({ score }) => score !== null) ?? []
    },
    outstandingRepurchaseRestructuring() {
      return (
        this.hasRole('ROLE_RESTRUCTURING') &&
        this.simulation.finance.restructuring?.actions.some(({ actionType }) => actionType === 'outstanding_repurchase')
      )
    },
    isCanceled() {
      return this.simulation.status === 'CANCELED'
    },
  },

  methods: {
    paramsDecision(dec) {
      if (dec.demand !== null && dec.demand !== undefined && dec.demand.id !== null && dec.demand.id !== undefined) {
        return { decisionId: dec.id, id: dec.demand.id }
      } else {
        return { decisionId: dec.id }
      }
    },
    updateData(newData) {
      const formRef = `formdemand${this.decisionId}`
      if (!this.formDatas.hasOwnProperty(formRef)) {
        this.formDatas[formRef] = newData
      }
    },
    updateSecondData(newData) {
      this.secondFormData = newData
    },
    getEligibility(eligibility) {
      return this.getEligibilityElements(eligibility).join('\n')
    },
    getEligibilityElements(eligibility) {
      let elements = []
      for (let criteria in eligibility) {
        if (eligibility[criteria].result == false) {
          elements.push(
            eligibility[criteria].message && eligibility[criteria].message != ''
              ? eligibility[criteria].message
              : this.$t('simulation.result.criteriaNotEligible', { criteria: eligibility[criteria].label }),
          )
        }
      }

      return elements
    },
    getStatusColor(status) {
      switch (status) {
        case 'CREATED':
        case 'NONE':
        case 'EXPIRED':
        case 'ALREADY_ASSIGN':
          return 'gray'
        case 'CLIENT_REQUEST':
        case 'STUDY':
        case 'TO_BE_COMPLETED':
        case 'REQUESTED':
        case 'CLIENT_PROPOSAL':
        case 'PREACCEPTED':
        case 'DETAILLED_STUDY':
        case 'UPDATED':
          return '#337ab7'
        case 'ACCEPTEDS':
        case 'ACCEPTED':
        case 'CHANGED':
        case 'ACCEPTED_FORCED':
        case 'CLIENT_ACCEPTED':
        case 'CLIENT_CONTRACT':
          return 'lightgreen'
        case 'CONDITIONAL':
          return 'green'
        case 'NOT_ACCEPTED':
          return '#f39c12'
        case 'DEFINITIVE_REFUSAL':
        case 'REFUSED':
        case 'CLIENT_REFUSED':
          return 'lightcoral'
        case 'ERROR':
          return 'red'
      }
    },
    isAccepted(status) {
      return ['ACCEPTED', 'CONDITIONAL', 'ACCEPTEDS', 'CHANGED', 'ACCEPTED_FORCED'].includes(status)
    },
    selectDecision(decisionId, keepRent = false) {
      this.sendingSelectDecision = true
      let action = keepRent ? '/selectrent' : '/select'
      this.patchJSON('decisions/' + decisionId + action, {}).then(
        (json) => {
          location.reload()
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    sendRefused() {
      this.$refs.formrefused.methods('patch')
    },
    sendDemand(decisionId, send) {
      if (!this.isClientSirenValid()) {
        return
      }

      if (send) {
        this.sending = 'demand'
      }

      this.$refs['formdemand' + decisionId][0].datas['decisionId'] = decisionId
      this.$refs['formdemand' + decisionId][0].datas['send'] = send

      delete this.$refs['formdemand' + decisionId][0].datas['status']

      return this.$refs['formdemand' + decisionId][0].methods('post')
    },
    isClientSirenValid() {
      if (!this.simulation.client.siren) {
        this.$root.jsonStatus = 'error'
        this.$root.jsonStatusText = this.$t('demand.error.missingSiren')
        $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
        return false
      }
      return true
    },
    sendResponse(decisionId, refresh) {
      this.sending = 'response'

      this.$nextTick(() => {
        if (refresh) {
          this.$refs['formdemand' + decisionId][0].datas['refresh'] = refresh
        }
        if (this.isAccepted(this.$refs['formdemand' + decisionId][0].datas['status']) === false) {
          this.$refs['formdemand' + decisionId][0].errors.demandNumber = false
          this.$refs['formdemand' + decisionId][0].datas['save_communication'] = true
        }
        delete this.$refs['formdemand' + decisionId][0].datas['decisionMessage']
        this.$refs['formdemand' + decisionId][0].datas['send'] = false
        this.$refs['formdemand' + decisionId][0].methods('patch')
      })
    },
    sendCommunication(decisionId) {
      this.sending = 'communication'
      if (this.isAccepted(this.$refs['formdemand' + decisionId][0].datas['status']) === false) {
        this.$refs['formdemand' + decisionId][0].errors.demandNumber = false
        this.$refs['formdemand' + decisionId][0].datas['save_communication'] = true
      }
      this.$refs['formdemand' + decisionId][0].datas['send'] = false
      this.$nextTick(() => {
        this.$refs['formdemand' + decisionId][0].methods('patch')
      })
    },
    transmitDemand(decisionId) {
      this.sending = 'transmit'
      this.$nextTick(() => {
        if (this.isAccepted(this.$refs['formdemand' + decisionId][0].datas['status']) === false) {
          this.$refs['formdemand' + decisionId][0].errors.demandNumber = false
          this.$refs['formdemand' + decisionId][0].datas['save_communication'] = true
        }
        this.$refs['formdemand' + decisionId][0].datas['send'] = true
        this.$refs['formdemand' + decisionId][0].datas['decisionId'] = decisionId
        this.$refs['formdemand' + decisionId][0].methods('patch')
      })
    },
    sendMessageUp() {
      this.$refs['formdemand' + this.decisionId][0].get()
    },
    showModal(demandId) {
      this.$nextTick(() => {
        if (this.$refs['messageList' + demandId][0] && this.$refs['messageList' + demandId][0].$refs.messageForm) {
          this.$refs['messageList' + demandId][0].$refs.messageForm.showForm()
        } else {
          $('#modal-message' + demandId).modal('toggle')
        }
      })
    },
    showEligibility(decision) {
      this.decision = decision

      this.$nextTick(() => {
        this.$refs['modal-eligibility'].open()
      })
    },
    showDeal(decisionId) {
      this.$refs['formdemand' + decisionId][0].errors['demandNumber'] = false
      this.$refs['decisiondeal' + decisionId][0].showModal()
    },
    displayArrow(e, decisionId) {
      this.decisionId = decisionId

      if (!this.collapseForm.includes(decisionId)) {
        this.collapseForm.push(decisionId)
      }

      let icon = e.target.closest('i') || e.target.querySelector('i')

      if (icon) {
        icon.classList.toggle('fa-arrow-down')
        icon.classList.toggle('fa-arrow-up')
      }
    },
    setBuildDemand(bool) {
      if (bool && !this.collapseField.includes(this.decisionId)) {
        this.collapseField.push(this.decisionId)
      }
    },

    async setElementDemand(def, obj) {
      let demand = obj
      const decisionId = demand.decisionOrg.id
      delete obj.decisiongOrg
      if (demand.decisionOrg) {
        const acceptedDemands = await this.getAcceptedDemands(decisionId)
        this.decisions = this.decisions.map((dec) => {
          if (dec.id === decisionId) {
            demand.decisionOrg['demand'] = demand
            demand.decisionOrg['acceptedDemands'] = acceptedDemands
            return demand.decisionOrg
          }

          return dec
        })
      }
    },
    async getAcceptedDemands(decisionId) {
      return await this.getJSON('decisions/' + decisionId + '/accepted')
    },
    setDecision(decision) {
      this.decisions = this.decisions.map((dec) => {
        if (dec.id === decision.id) {
          return decision
        }
        return dec
      })
      this.simulation.status = decision.simulation.status
      this.refreshAcceptedDemandsSummary()
      this.$nextTick(() => {
        this.$refs['formdemand' + decision.id][0].get()
      })
    },
    setLoading(bool) {
      this.loading = bool
    },
    isLoading(decisionId) {
      return this.loading && this.decisionId === decisionId
    },
    isSending(bool) {
      switch (this.sending) {
        case 'demand':
          this.sendingDemand = bool
          break
        case 'response':
          this.sendingResponse = bool
          break
        case 'communication':
          this.sendingCommunication = bool
          break
        default:
          this.sendingTransmit = bool
      }
    },
    setDatasDemand(demand, { datas }) {
      //pour refresh le formCreator
      this.$refs['formdemand' + demand.decisionOrg.id][0].get()

      this.$emit('demand-sent', demand)

      if (demand.decisionOrg) {
        this.decisions = this.decisions.map((dec) => {
          if (dec.id === demand.decisionOrg.id) {
            demand.decisionOrg['demand'] = demand
            return demand.decisionOrg
          }

          return dec
        })

        if (demand.decisionOrg.status === 'CREATED' && datas.send) {
          this.showModal(demand.id)
        }
      }

      if (this.$refs['documentList' + demand.id] !== undefined) {
        this.$refs['documentList' + demand.id][0].getDocuments()
      }
      if (this.$refs['messageList' + demand.id] !== undefined) {
        this.$refs['messageList' + demand.id][0].callbackMessage()
      }
      if (this.$refs['alertlist' + demand.id] !== undefined) {
        this.$refs['alertlist' + demand.id][0].loadAlert()
      }
    },
    updateDemand(demand) {
      this.$emit('demand-sent', demand)
    },
    getAlert(demandId) {
      if (this.$refs['alertlist' + demandId] !== undefined) {
        this.$refs['alertlist' + demandId][0].loadAlert()
      }
      this.$emit('call:alert')
    },
    onDocumentUploaded(demandId) {
      this.getAlert(demandId)
      this.$emit('update-simulation')
    },
    createQuotation() {
      let value = {
        simulationId: this.simulation.id,
        changed: true,
      }

      this.postJSON('quotation', value, {}).then(
        (json) => {
          location = 'devis.php?i=' + json.simulationIdCreated
        },
        (reason) => {
          alert(reason)
        },
      )
    },
    setDatas(json) {
      this.$emit('update-simulation')
    },
    canRecomputeDecision({ status }) {
      return status === 'CREATED'
    },
    isRecomputingDecision({ id }) {
      return this.recomputingDecision === id
    },
    async recomputeDecision(decisionId) {
      try {
        this.recomputingDecision = decisionId
        await this.sendDemand(decisionId, false)
      } catch (reason) {
        alert(reason)
      } finally {
        this.recomputingDecision = null
      }
    },
    changePurchaseRate(decision, purchaseRate) {
      this.isPurchaseRateChanged[decision.id] = purchaseRate != decision.demand.purchaseRate
    },
    changePurchaseRateSent(decision, purchaseRateSent) {
      this.isPurchaseRateSentChanged[decision.id] = purchaseRateSent != decision.demand.purchaseRateSent
    },
    isPurchaseRateDisabled(decision) {
      return decision.demand.purchaseRateManualUpdate !== null || this.isPurchaseRateChanged[decision.id]
    },
    isPurchaseRateSentDisabled(decision) {
      return decision.demand.purchaseRateSentManualUpdate !== null || this.isPurchaseRateSentChanged[decision.id]
    },
    isUpdatingPurchaseRate(decisionId) {
      return this.updatePurchaseRateUpdating === decisionId
    },
    updatePurchaseRate(decision) {
      this.updatePurchaseRateConfirming = decision
      this.$refs.modalConfirmationUpdatePurchaseRate.showModal()
    },
    async confirmUpdatePurchaseRate() {
      this.$refs.modalConfirmationUpdatePurchaseRate.closeModal()
      const { id, transferAmount } = this.updatePurchaseRateConfirming
      try {
        this.updatePurchaseRateUpdating = id
        const decision = await this.patchJSON(`decisions/${id}/updatePurchaseRate`)
        const result = decision.transferAmount === transferAmount ? 'purchaseRateUnchanged' : 'purchaseRateUpdated'
        this.success = this.$t(`demand.success.${result}`)
        this.$refs['modalSuccess'].open()
        if (result === 'purchaseRateUpdated') {
          this.$refs['formdemand' + id][0].get()
        }
      } finally {
        this.updatePurchaseRateUpdating = null
      }
    },
    initTimer() {
      this.orderedDecisions.forEach((decision) => {
        if (decision.pendingWaitingEndDate) {
          //le format de pendingWaitingEndDate doit être comme : 2025-03-31T14:48:46+00:00
          this.timerEndDate = DateTime.fromISO(decision.pendingWaitingEndDate)
        }
      })
    },
    getHTMLTimerValue(timer) {
      if (timer.days > 0) {
        return timer.toFormat("d '" + this.$t('dateTime.day') + "' hh:mm:ss'")
      } else if (timer.hours > 0) {
        return timer.toFormat("hh:mm:ss'")
      } else {
        return timer.toFormat("mm:ss'")
      }
    },
    localRenderEntity(entity) {
      return this.$root.renderEntity(entity)
    },
    getScoreWithScale(score) {
      let value = score.score
      if (score.provider === 'Credit Safe') {
        value = score.score / 10
      }

      let scale = 10
      if (value >= 10) {
        scale = 100
      }

      return `${value}/${scale}`
    },
    async setApiSynced(dec) {
      const action = dec.demand.isApiSynced ? 'unsynchronize' : 'synchronize'
      const json = await this.patchJSON(`demands/${dec.demand.id}/api/${action}`, {}, {})
      this.decisions = this.decisions.map((decision) => {
        if (decision.id === dec.id) {
          return {
            ...decision,
            demand: json,
          }
        }
        return decision
      })
    },
    canSynchronizePurchaseRate(decision) {
      return this.hasRole(Role.REFRESH_PURCHASE_RATE) && decision.refinancer.purchaseRateSynchronizationEnabled
    },
    getResidualValueLabel({ demand }) {
      if (demand?.residualMode === ResidualMode.AMOUNT) {
        return this.$t('demand.fields.residualAmountSent.label')
      } else {
        return this.$t('demand.fields.residualPercentSent.label')
      }
    },
  },
  mounted() {
    this.decisions = [...this.simulation.decisions]
    this.refreshAcceptedDemandsSummary()
    this.initTimer()
  },
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BlockContent e2e-block="simulationScore">
          <h5>{{ $t('entity.score.client') }} <EntityLink :entity="client" e2e-data="simulationClient" /></h5>
          <div class="row mb-1" v-for="score in scores" :key="score.provider" :data-test-id="score.provider">
            <div class="col-md-7">
              <b class="mr-1">
                {{ score.provider + ' (' + $root.setDate(score.scoreAt) + ') :' }}
                <span data-test-id="score-value" e2e-data="simulationScore">{{ getScoreWithScale(score) }}</span>
              </b>
              <i :class="score.status"></i>
            </div>
            <div class="col-md-5" v-if="['Credit Safe', 'Ellisphere'].includes(score.provider)">
              {{ $t('entity.information.score.limit') }} :
              <span data-test-id="credit-limit" e2e-data="simulationCreditLimit">
                {{
                  $n(
                    Number(score.provider === 'Credit Safe' ? client.creditLimitCS : client.creditLimitEli),
                    'currency',
                  )
                }}
              </span>
            </div>
          </div>
          <div class="my-4" style="border-bottom: 1px solid #eee"></div>
          <h5>{{ $t('entity.information.exposition.title') }}</h5>
          <div class="table-responsive">
            <table class="table w-100 table-borderless align-middle">
              <tbody>
                <tr>
                  <td class="title text-dark align-middle fs-16" style="min-width: 0">
                    <b>{{ $t('entity.information.exposition.outstanding') }}</b>
                  </td>
                  <td class="text-right">
                    <span
                      class="badge badge-pill fs-14 ml-1 badge-secondary mr-2"
                      style="min-width: 10%"
                      e2e-data="simulationOutstanding"
                    >
                      {{ client.outstanding ? client.outstanding.number : 0 }}
                    </span>
                  </td>
                  <td class="text-right">
                    <span
                      class="badge badge-pill fs-14 ml-1 badge-secondary"
                      style="min-width: 20%"
                      e2e-data="simulationOutstandingAmount"
                    >
                      {{ $n(Number(client.outstanding?.amount ?? 0), 'currency', { notation: 'compact' }) }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="title text-dark align-middle fs-16" style="min-width: 0">
                    <b>{{ $t('entity.information.exposition.availableDemands') }}</b>
                  </td>
                  <td class="text-right">
                    <span
                      class="badge badge-pill fs-14 ml-1 badge-secondary mr-2"
                      style="min-width: 10%"
                      e2e-data="simulationDemandsExpo"
                    >
                      {{ acceptedDemandsSummary.number }}
                    </span>
                  </td>
                  <td class="text-right">
                    <span
                      class="badge badge-pill fs-14 ml-1 badge-secondary"
                      style="min-width: 20%"
                      e2e-data="simulationDemandsExpoAmount"
                    >
                      {{ $n(acceptedDemandsSummary.amount, 'currency', { notation: 'compact' }) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </BlockContent>
      </div>
      <div class="col-md-6">
        <BlockContent v-if="simulation" e2e-block="simulationRefused">
          <h5>{{ $t('simulation.result.refused') }}</h5>

          <FormCreator
            @update-data="updateSecondData"
            ref="formrefused"
            endpoint="quotations"
            method="patch"
            :id="simulation.id"
            :config-def="simulationDef"
            :config-object="simulation"
            :dynamic="true"
            :params="{ simulationId: simulation.id }"
            class-to-add="d-none"
            @form-return="setDatas"
            @is-sending="isSending"
          />

          <FieldCreator
            v-if="secondFormData"
            :form-data="secondFormData"
            name="commentRefused"
            form-ref="formrefused"
            domain="simulation"
            :label-top="true"
          ></FieldCreator>

          <FieldCreator
            v-if="secondFormData"
            :form-data="secondFormData"
            name="refused"
            form-ref="formrefused"
            domain="simulation"
            :label-top="true"
          ></FieldCreator>

          <button
            v-if="!user.isReadOnly && !isCanceled"
            :class="'btn btn-' + (simulation.commentRefused == null ? 'primary' : 'warning')"
            @click="sendRefused"
            e2e-button="sendRefused"
          >
            {{ simulation.commentRefused == null ? $t('simulation.sendComment') : $t('simulation.modifyComment') }}
          </button>

          <span id="commentRefusedError" class="text-danger"></span>
        </BlockContent>
      </div>
    </div>

    <div
      v-if="orderedDecisions.length > 0"
      v-for="dec in orderedDecisions"
      class="panel-group p-2 mb-4"
      :id="'accordion-' + dec.id"
      role="tablist"
      aria-multiselectable="true"
    >
      <BlockContent
        :inner-bloc-class="mainDecisionId === dec.id ? 'border__dec--selected' : ''"
        :e2e-block="'decision-' + dec.refinancer.name"
      >
        <div class="panel panel-default">
          <div class="col">
            <div class="panel-heading row" role="tab" :id="'heading' + dec.id">
              <div class="col col-md-3">
                <div class="row">
                  <h4>{{ dec.refinancer.name }}</h4>
                </div>
                <div class="row">
                  <button
                    type="button"
                    @click="showEligibility(dec)"
                    :class="'ml-2 btn btn-' + (dec.isEligible ? 'success' : 'danger')"
                    e2e-button="decisionEligibility"
                  >
                    {{ dec.isEligible ? $t('simulation.result.eligible') : $t('simulation.result.notEligible') }}
                    <i
                      data-toggle="tooltip"
                      data-placement="right"
                      :title="getEligibility(dec.clientCriterias)"
                      class="fa fa-question-circle"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
              <div class="col col-md-2 p-2">
                <div
                  class="ml-2 badge d-inline"
                  :style="
                    'color:white;background-color:' +
                    getStatusColor(dec.demand === null ? dec.status : dec.demand.status)
                  "
                  e2e-data="decisionStatus"
                >
                  {{ $t('simulation.status.' + (dec.demand === null ? dec.status : dec.demand.status) + '.label') }}
                </div>
                <div
                  v-if="dec.orderToCall !== null && dec.orderToCall !== undefined"
                  class="ml-2 badge d-inline"
                  e2e-data="decisionOrderToCall"
                >
                  #{{ dec.orderToCall + 1 }}
                </div>
                <div v-if="dec.pendingWaitingEndDate && timerValue" class="ml-2 badge" e2e-data="decisionTimer">
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                  {{ timerValue }}
                </div>
              </div>
              <div v-if="dec.rent" class="col d-flex align-items-center">
                <div v-if="!isTheme('yneia')" class="col text-center">
                  <div
                    v-if="outstandingRepurchaseRestructuring"
                    class="text-primary"
                    e2e-data="decisionOutstandingBalance"
                  >
                    {{
                      $t('simulation.decision.refinancer.outstandingBalance', {
                        amount: $n(Number(dec.outstandingBalance ?? 0), 'currency'),
                      })
                    }}
                  </div>
                  <div>
                    <i class="fa fa-money mr-2"></i>
                    <span e2e-data="decisionRentAmount">{{ $n(Number(dec.rent?.amount ?? 0), 'currency') }}</span> -
                    <span e2e-data="decisionRent">{{
                      simulation.finance?.rentInfo?.hasLevel
                        ? $t('level.hasLevel')
                        : $n(Number(simulation.finance?.rentInfo?.rent ?? 0), 'currency')
                    }}</span>
                  </div>
                  <div class="text-success">
                    <strong>
                      <i class="fa fa-piggy-bank mr-2"></i>
                      <span e2e-data="decisionRentMargin">{{ $n(Number(dec.rent?.margin ?? 0), 'decimal') }}</span> % /
                      <span e2e-data="decisionRentProfitability">{{
                        $n(Number(dec.rent?.profitability ?? 0), 'currency')
                      }}</span>
                    </strong>
                  </div>
                </div>
                <div
                  v-if="hasRole('ROLE_DECISION_SELECT') && simulation.finance.computeType === 'AMOUNT'"
                  class="col d-flex justify-content-around"
                >
                  <ButtonAll
                    v-if="!isCanceled"
                    margin="no"
                    :loading="sendingSelectDecision"
                    type="validation"
                    @click="selectDecision(dec.id)"
                    label="simulation.decision.select.withRent"
                    name="decisionSelect"
                  />
                  <button
                    type="button"
                    class="btn btn-lg"
                    style="text-decoration: none"
                    role="button"
                    data-toggle="collapse"
                    :data-parent="'#accordion-' + dec.id"
                    :data-target="'#collapse' + dec.id"
                    aria-expanded="true"
                    :aria-controls="'collapse' + dec.id"
                    @click="displayArrow($event, dec.id)"
                    e2e-button="decisionShow"
                  >
                    <i class="fas fa-arrow-down"></i>
                  </button>
                </div>
                <div
                  v-else-if="hasRole('ROLE_DECISION_SELECT_RENT') && simulation.finance.computeType === 'RENT'"
                  class="col d-flex justify-content-around"
                >
                  <ButtonAll
                    v-if="!isCanceled"
                    margin="no"
                    type="validation"
                    :loading="sendingSelectDecision"
                    @click="selectDecision(dec.id, true)"
                    label="simulation.decision.select.keepRent"
                    name="decisionSelect"
                  />
                  <button
                    type="button"
                    class="btn btn-lg"
                    style="text-decoration: none"
                    role="button"
                    data-toggle="collapse"
                    :data-parent="'#accordion-' + dec.id"
                    :data-target="'#collapse' + dec.id"
                    aria-expanded="true"
                    :aria-controls="'collapse' + dec.id"
                    @click="displayArrow($event, dec.id)"
                    e2e-button="decisionShow"
                  >
                    <i class="fas fa-arrow-down"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            :id="'collapse' + dec.id"
            :ref="'collapse' + dec.id"
            class="mt-4 panel-collapse collapse in"
            role="tabpanel"
            :aria-labelledby="'heading' + dec.id"
          >
            <FormCreator
              v-if="collapseForm.includes(dec.id)"
              @update-data="updateData"
              :id="dec.demand?.id"
              :ref="'formdemand' + dec.id"
              endpoint="demands"
              :params="paramsDecision(dec)"
              class-to-add="d-none"
              @form-build="setBuildDemand"
              @element-build="setElementDemand"
              @is-loading="setLoading"
              @is-sending="isSending"
              @form-return="setDatasDemand"
              @update="updateDemand"
            />
            <DecisionDealModal
              :ref="'decisiondeal' + dec.id"
              :decision-id="dec.id"
              :refinancer-name="dec.refinancer.name"
              :demands="dec.acceptedDemands"
              :simulation-id="simulation.id"
              :is-canceled="isCanceled"
              @sent-decision="setDecision"
              @sent-demand="sendDemand(dec.id, true)"
            />
            <AlertList
              v-if="dec.demand?.id && collapseField.includes(dec.id) && hasRole('ROLE_ALERT_SHOW')"
              :ref="'alertlist' + dec.demand.id"
              context="AppBundle\Entity\Demand"
              :context-id="dec.demand.id"
              show
            />
            <div v-if="!isLoading(dec.id) && collapseField.includes(dec.id)" class="row mb-3">
              <div class="col-md-4">
                <div class="col-md-12 bloc card">
                  <h4 class="my-3 text-center">{{ $t('simulation.decision.demand') }}</h4>
                  <table class="fs-16">
                    <thead>
                      <tr>
                        <th class="form-label-font">{{ $t('demand.fields.durationSent.label') }}</th>
                        <th class="form-label-font">{{ getResidualValueLabel(dec) }}</th>
                        <th class="form-label-font">{{ $t('demand.fields.initialRentPercentSent.label') }}</th>
                        <th class="form-label-font">{{ $t('demand.fields.purchaseRateSent.label') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="durationSent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                          />
                        </td>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="residualPercentSent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                          />
                          <FieldCreator
                            :form-data="formDatas"
                            name="residualAmountSent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                          />
                        </td>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="initialRentPercentSent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                          />
                        </td>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="purchaseRateSent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                            @get-input-change="changePurchaseRateSent(dec, $event)"
                          >
                            <template
                              v-if="dec.status === DecisionStatus.CREATED && canSynchronizePurchaseRate(dec)"
                              #button
                            >
                              <ButtonAll
                                type="input"
                                icon="refresh"
                                :tip="
                                  isPurchaseRateSentDisabled(dec)
                                    ? 'demand.buttons.purchaseRateManualUpdate'
                                    : 'demand.buttons.updatePurchaseRate'
                                "
                                :disabled="isPurchaseRateSentDisabled(dec)"
                                :loading="isUpdatingPurchaseRate(dec.id)"
                                name="decisionUpdatePurchaseRate"
                                @click="updatePurchaseRate(dec)"
                              />
                            </template>
                          </FieldCreator>
                        </td>
                      </tr>
                      <tr v-if="canRecomputeDecision(dec)">
                        <td colspan="4">
                          <ButtonAll
                            label="simulation.decision.button.recompute"
                            type="validation"
                            width="full"
                            :loading="isRecomputingDecision(dec)"
                            @click="recomputeDecision(dec.id)"
                            e2e-button="decisionRecompute"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="row">
                    <div class="col-md-12" v-if="hasRole('ROLE_ADVANCE_DECISION_SHOW')">
                      <FieldCreator
                        :form-data="formDatas"
                        name="createdBy"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                      />
                    </div>
                    <div class="col-md-12" v-if="hasRole('ROLE_ADVANCE_DECISION_SHOW')">
                      <FieldCreator
                        :form-data="formDatas"
                        name="refinancerCategorySent"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        :decision-id="dec.id"
                        label-top
                        to-post
                      />
                    </div>
                    <div class="col-md-12">
                      <FieldCreator
                        :form-data="formDatas"
                        name="amountSent"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                      />
                    </div>
                    <div class="col-md-12">
                      <div class="my-2">
                        <label class="fs-16 form-label-font"
                          >{{ $t('demand.list.totalAmount') }} :
                          {{ $n(Number(simulation.finance.amount ?? 0), 'currency') }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <ButtonAll
                    v-if="!isCanceled"
                    type="validation"
                    label="demand.buttons.send"
                    @click="sendDemand(dec.id, true)"
                    :loading="sendingDemand"
                    name="decisionSendDemand"
                  />
                  <ButtonAll
                    v-if="dec.acceptedDemands?.length > 0"
                    type="validation"
                    label="demand.buttons.accepted"
                    @click="showDeal(dec.id)"
                    name="decisionShowDeal"
                  />
                </div>
              </div>
              <div v-if="dec.status !== 'CREATED'" class="col-md-4">
                <div class="col-md-12 bloc card mb-0">
                  <h4 class="my-3 text-center">{{ $t('simulation.decision.response') }}</h4>
                  <table class="fs-16">
                    <thead>
                      <tr>
                        <th class="form-label-font">{{ $t('demand.fields.finance.duration.label') }}</th>
                        <th class="form-label-font">{{ getResidualValueLabel(dec) }}</th>
                        <th class="form-label-font">{{ $t('demand.fields.finance.initialRentPercent.label') }}</th>
                        <th class="form-label-font">{{ $t('demand.fields.purchaseRate.label') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="finance.duration"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                          />
                        </td>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="finance.residualPercent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                            type-value="float"
                          />
                          <FieldCreator
                            :form-data="formDatas"
                            name="finance.residualValue"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                            type-value="float"
                          />
                        </td>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="finance.initialRentPercent"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                          />
                        </td>
                        <td>
                          <FieldCreator
                            :form-data="formDatas"
                            name="purchaseRate"
                            :form-ref="'formdemand' + dec.id"
                            domain="demand"
                            @get-input-change="changePurchaseRate(dec, $event)"
                          >
                            <template #button v-if="canSynchronizePurchaseRate(dec)">
                              <ButtonAll
                                type="input"
                                icon="refresh"
                                :tip="
                                  isPurchaseRateDisabled(dec)
                                    ? 'demand.buttons.purchaseRateManualUpdate'
                                    : 'demand.buttons.updatePurchaseRate'
                                "
                                :disabled="isPurchaseRateDisabled(dec)"
                                @click="updatePurchaseRate(dec)"
                                :loading="isUpdatingPurchaseRate(dec.id)"
                                name="decisionUpdatePurchaseRate"
                              />
                            </template>
                          </FieldCreator>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="row">
                    <div class="col-md-12">
                      <FieldCreator
                        :form-data="formDatas"
                        name="status"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        type-value="string"
                        label-top
                      />
                    </div>
                    <div class="col-md-12" v-if="dec.demand.id && dec.demand.apiSentAt !== null">
                      <label for="isApiSynced" style="font-size: 16px">
                        <input
                          v-if="!isCanceled"
                          type="checkbox"
                          id="isApiSynced"
                          name="isApiSynced"
                          :checked="dec.demand.isApiSynced"
                          @click="setApiSynced(dec)"
                        />
                        &nbsp;{{ $t('demand.fields.isApiSynced.label') }}
                      </label>
                    </div>
                    <div class="col-md-12">
                      <FieldCreator
                        :form-data="formDatas"
                        name="refinancerCategory"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                        update
                      />
                    </div>
                    <div class="col-md-12">
                      <FieldCreator
                        :form-data="formDatas"
                        name="finance.amount"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                      />
                    </div>
                    <div class="col-md-12">
                      <FieldCreator
                        :form-data="formDatas"
                        name="decisionValidity"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                      />
                    </div>
                    <div class="col-md-12">
                      <FieldCreator
                        :form-data="formDatas"
                        name="demandNumber"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                      />
                    </div>
                    <div class="col-md-12">
                      <FieldCreator
                        v-if="hasRole('ROLE_ADVANCE_DECISION_SHOW')"
                        :form-data="formDatas"
                        name="guarantees"
                        :form-ref="'formdemand' + dec.id"
                        domain="demand"
                        label-top
                        select-multiple
                      />
                    </div>
                  </div>
                  <ButtonAll
                    v-if="!isCanceled"
                    type="validation"
                    label="demand.buttons.response"
                    @click="sendResponse(dec.id, false)"
                    :loading="sendingResponse"
                    name="decisionSendResponse"
                  />
                </div>
              </div>
              <div v-if="dec.status !== 'CREATED'" class="col-md-4">
                <div class="col-md-12 bloc card">
                  <h4 class="my-3 text-center">{{ $t('simulation.decision.communication') }}</h4>
                  <FieldCreator
                    v-if="hasRole('ROLE_ADVANCE_DECISION_SHOW')"
                    :form-data="formDatas"
                    name="mandatories"
                    :form-ref="'formdemand' + dec.id"
                    domain="demand"
                    label-top
                    select-multiple
                  />
                  <FieldCreator
                    :form-data="formDatas"
                    name="decisionMessage"
                    :form-ref="'formdemand' + dec.id"
                    domain="demand"
                    label-top
                    editor
                  />
                  <ButtonAll
                    v-if="!isCanceled"
                    type="validation"
                    label="demand.buttons.communication"
                    @click="sendCommunication(dec.id)"
                    :loading="sendingCommunication"
                    name="decisionSendCommunication"
                  />
                  <ButtonAll
                    v-if="!isCanceled"
                    type="validation"
                    label="demand.buttons.transmit"
                    @click="transmitDemand(dec.id)"
                    :loading="sendingTransmit"
                    name="decisionTransmitDemand"
                  />
                </div>
              </div>
            </div>
            <div v-else class="row mb-3">
              <div class="col-md-4">
                <div class="col-md-12 bloc card">
                  <h4 class="my-3 text-center">{{ $t('simulation.decision.demand') }}</h4>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-4 mb-3 loading"></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="col-md-12 bloc card">
                  <h4 class="my-3 text-center">{{ $t('simulation.decision.response') }}</h4>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-4 mb-3 loading"></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="col-md-12 bloc card">
                  <h4 class="my-3 text-center">{{ $t('simulation.decision.communication') }}</h4>
                  <div class="row py-4 mb-3 loading"></div>
                  <div class="row py-5 mb-3 loading"></div>
                </div>
              </div>
            </div>
            <div v-if="dec.demand && collapseField.includes(dec.id)" class="row">
              <div class="col" v-if="dec.demand.id">
                <MessageList
                  :ref="'messageList' + dec.demand.id"
                  :active="simulation.status"
                  context="AppBundle\Entity\Demand"
                  :context-id="dec.demand.id"
                  :additional-contexts="messageListContext"
                  api-call
                  @update="sendMessageUp"
                />
              </div>
              <div class="col card" v-if="dec.demand.id">
                <DocumentList
                  :id="String(dec.id)"
                  :ref="'documentList' + dec.demand.id"
                  context="Demand"
                  :context-id="dec.demand.id"
                  @document-uploaded="onDocumentUploaded"
                  @document-deleted="getAlert"
                />
              </div>
            </div>
          </div>
        </div>
      </BlockContent>
    </div>
    <ModalConfirmation
      ref="modalConfirmationUpdatePurchaseRate"
      id="confirmUpdatePurchaseRate"
      @confirm="confirmUpdatePurchaseRate"
      title="demand.confirmations.updatePurchaseRate"
      button-cancel-title="main.close"
    ></ModalConfirmation>
    <ModalSuccess ref="modalSuccess" id="modalSuccess" :success="success" />
    <ModalDialog
      v-if="decision"
      :id="'modal-eligibility-' + decision.id"
      ref="modal-eligibility"
      :title-t="$t('simulation.result.eligibility')"
      class-modal-dialog="modal-xl"
      e2e-modal="modal-eligibility"
    >
      <div>
        <ul class="list-group">
          <li
            v-for="criteria in decision.clientCriterias"
            :class="'list-group-item text text-' + (criteria.result ? 'success' : 'danger')"
          >
            <i :class="{ fas: true, 'fa-check-circle': criteria.result, 'fa-times-circle': !criteria.result }"></i
            >&nbsp;
            {{
              criteria.message !== ''
                ? criteria.message
                : $t('simulation.result.criteriaNotEligible', { criteria: criteria.label })
            }}
          </li>
        </ul>
      </div>
    </ModalDialog>
  </div>
</template>
